const t = (o) => o ? new Promise((r) => {
  o.toBlob((e) => {
    r(e);
  });
}) : null;
export {
  t as getBlobFromCanvas
};
//# sourceMappingURL=Crop.utils.es.js.map
